"use strict";
/* eslint-disable indent */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldSection = exports.StyledDefaultSectionHeader = exports.mixins = exports.HiddenAriaDescription = exports.EmptyStateParagraph = exports.EmailWrapperWithConfirm = exports.EmailWrapper = exports.SubmitWrapper = exports.DOBWrapper = exports.FieldListHeader = exports.FieldListItemStyle = exports.StyledPhoneInput = exports.TextRowSpaceBottom = exports.TextRowSpaceBetween = exports.FieldFocusWrapper = exports.FieldErrorWrapper = exports.ErrorList = exports.ErrorListItemMessage = exports.ErrorListMessage = exports.ErrorMessage = exports.TextButton = exports.UppercaseHeading = exports.Label = exports.ItalicizedText = exports.Text = exports.FieldStyles = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.FieldStyles = styled_1.default.div `
  order: ${(props) => props.order};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  flex: ${({ flexGrow }) => flexGrow};
  height: 100%;

  @media screen and (min-width: ${({ breakpoints = {} }) => breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')}) {
    margin-bottom: 0;
    &:not(:last-of-type) {
      margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    }
  }
`;
exports.Text = styled_1.default.div `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.Text.defaultProps = { 'data-testid': 'forms-v2-text' };
exports.ItalicizedText = (0, styled_1.default)(exports.Text) `
  font-style: italic;
`;
exports.Label = (0, styled_1.default)(exports.Text) `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.UppercaseHeading = (0, styled_1.default)(exports.Text) `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  text-transform: uppercase;
`;
exports.TextButton = styled_1.default.button `
  cursor: pointer;
  background: none;
  border: none;
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  max-width: 200px;
  text-align: left;
  cursor: pointer;
  outline: none;
  &:focus {
    text-decoration: underline;
  }
`;
exports.ErrorMessage = (0, styled_1.default)(exports.Text) `
  color: ${(0, ui_theme_1.fromTheme)('color_danger')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
`;
exports.ErrorListMessage = (0, styled_1.default)(exports.ErrorMessage) `
  margin: 0;
`;
exports.ErrorListItemMessage = styled_1.default.span `
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  color: ${(0, ui_theme_1.fromTheme)('color_danger')};
  margin: 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_small')};
`;
exports.ErrorList = styled_1.default.ul `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  padding-left: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  list-style-position: inside;
`;
exports.FieldErrorWrapper = styled_1.default.div `
  height: 100%;

  .react-phone-number-input__row input.react-phone-number-input__input,
  input[type='tel'],
  & input,
  & select,
  & button,
  & .field-error-wrapper,
  & .field-error-wrapper > div {
    border-color: ${({ errors }) => errors.length ? (0, ui_theme_1.fromTheme)('color_danger') : null};

    background-color: ${({ errors }) => errors.length ? (0, ui_theme_1.fromTheme)('color_danger_secondary') : null};

    border-width: ${({ errors }) => errors.length ? (0, ui_theme_1.fromTheme)('border_width') : null};
  }

  /* Used specifically for multiSelect type */
  & .field-error-wrapper > div > div > div {
    background-color: ${({ errors }) => errors.length ? (0, ui_theme_1.fromTheme)('color_danger_secondary') : null};

    border-color: ${({ errors }) => errors.length ? (0, ui_theme_1.fromTheme)('color_danger') : 'none'};
  }

  /* Used specifically for dateInput type */
  & .SingleDatePickerInput__showClearDate,
  & .SingleDatePickerInput {
    padding-right: 0;
    > .DateInput {
      width: 100%;
      > .DateInput_input {
        width: 100%;
        text-align: left;
        padding-left: 16px;
      }
    }
  }
`;
exports.FieldFocusWrapper = styled_1.default.div `
  height: 100%;

  & input:focus, /* input */
  & textarea:focus, /* textarea */
  & button:focus, /* select */
  & select:focus /* simpleSelect */ {
    outline-color: ${({ hasError }) => hasError ? (0, ui_theme_1.fromTheme)('color_danger') : (0, ui_theme_1.fromTheme)('color_link')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: solid;
    outline-offset: 0px;
  }

  /* checkbox */
  & input[type='checkbox']:focus + span {
    outline-color: ${({ hasError }) => hasError ? (0, ui_theme_1.fromTheme)('color_danger') : (0, ui_theme_1.fromTheme)('color_link')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: solid;
    outline-offset: 0px;
  }

  /* Make sure invisible input for creatable items in Typeahead and Multiselect does not have outline*/
  & div[role='combobox'] input:focus {
    outline-style: none;
  }
`;
exports.TextRowSpaceBetween = styled_1.default.div `
  display: flex;
  justify-content: space-between;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_xsmall')}
    ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
`;
exports.TextRowSpaceBottom = (0, styled_1.default)(exports.TextRowSpaceBetween) `
  padding: 0px ${(0, ui_theme_1.fromTheme)('spacing_xsmall')} ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0px;
`;
exports.StyledPhoneInput = (0, styled_1.default)(exports.Text) `
  input,
  input.react-phone-number-input__input {
    height: inherit;
    border: unset;
    padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
    text-align: left;
    border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_border')};
    box-sizing: border-box;
    width: 100%;
    outline: none;
    &:disabled {
      color: ${(0, ui_theme_1.fromTheme)('color_text_disabled')};
    }
    &::placeholder {
      color: ${({ hasError }) => {
    return hasError
        ? (0, ui_theme_1.fromTheme)('color_text')
        : (0, ui_theme_1.fromTheme)('color_text_placeholder');
}}
  }
  .react-phone-number-input__country-select:focus
    + .react-phone-number-input__country-select-arrow,
  .react-phone-number-input__country.rrui__select--focus .rrui__select__arrow {
    color: ${(0, ui_theme_1.fromTheme)('color_text')};
  }

  /* focus border style  */
  .react-phone-number-input__row input.react-phone-number-input__input:focus,
  input[type='tel']:focus {
    outline-color: ${({ hasError }) => hasError ? (0, ui_theme_1.fromTheme)('color_danger') : (0, ui_theme_1.fromTheme)('color_link')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: solid;
    outline-offset: 0px;
  }
`;
exports.FieldListItemStyle = styled_1.default.div `
  border-bottom: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};

  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  &:last-of-type {
    border-bottom: none;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  }
`;
exports.FieldListHeader = styled_1.default.div `
  display: flex;
  justify-content: flex-end;
`;
exports.DOBWrapper = styled_1.default.div `
  & input {
    text-align: center;

    &::placeholder {
      text-align: center;
    }

    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
  }

  & > div {
    justify-content: flex-start;
    padding-left: 10px; /* 10px used to align <DynamicInput /> with form */
  }

  & > div > div.inpuut {
    flex: 0 1 40px; /* 40px used to align <DynamicInput /> with form */
    height: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};

    input[aria-label*='-input'] {
      border: none;
    }

    &:after {
      content: '/';
      line-height: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
    }

    &:last-child {
      &:after {
        content: '';
        display: none;
      }
    }
  }

  /* focus border style  */
  &.field-error-wrapper > div {
    outline-color: ${({ isFocused, hasError }) => {
    if (!isFocused)
        return;
    if (hasError)
        return (0, ui_theme_1.fromTheme)('color_danger');
    return (0, ui_theme_1.fromTheme)('color_link');
}};
    outline-width: ${({ isFocused }) => isFocused && (0, ui_theme_1.fromTheme)('border_width')};
    outline-style: ${({ isFocused }) => isFocused && 'solid'};
    outline-offset: ${({ isFocused }) => isFocused && '0px'};
  }
`;
exports.SubmitWrapper = styled_1.default.div `
  display: flex;
  justify-content: flex-end;
  & > button {
    width: 100%;
    @media screen and (min-width: ${({ breakpoints = {} }) => breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')}) {
      width: auto;
    }
  }
`;
exports.EmailWrapper = styled_1.default.div `
  @media screen and (min-width: ${({ breakpoints = {} }) => breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')}) {
    display: flex;
    & > div {
      flex-basis: 100%;
    }
  }
`;
// like EmailWrapper but supports spacing for including the
// included optional `confirm` field
exports.EmailWrapperWithConfirm = styled_1.default.div `
  @media screen and (min-width: ${({ breakpoints = {} }) => breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')}) {
    display: flex;
    & > div {
      width: 50%;
    }
    & > div:first-of-type {
      margin-right: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    }
  }
`;
exports.EmptyStateParagraph = styled_1.default.p `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  margin: 0;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.HiddenAriaDescription = styled_1.default.p `
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  left: -10000px;
`;
exports.mixins = {
    rowWidth: (params) => {
        const { theme, width = 'xl', breakpoints = {} } = params;
        // For sizes that don't take the whole screen, have to subtract half of
        // the spacing to match up with flexed elements. (See KENG-13972)
        const widths = {
            xl: '100%',
            l: `calc(50% - (${(0, ui_theme_1.fromTheme)('spacing_medium')({ theme })}/2))`,
            m: `calc(33% - (${(0, ui_theme_1.fromTheme)('spacing_medium')({ theme })}/2))`,
            s: `calc(25% - (${(0, ui_theme_1.fromTheme)('spacing_medium')({ theme })}/2))`
        };
        return `
  @media screen and (min-width: ${breakpoints.screen_medium || (0, ui_theme_1.fromTheme)('screen_medium')({ theme })}) {
    width: ${widths[width]};
    };
  `;
    }
};
exports.StyledDefaultSectionHeader = (0, styled_1.default)('div') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.StyledFieldSection = (0, styled_1.default)('div') `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};

  &:first-of-type {
    margin-top: 0;
  }
`;
//# sourceMappingURL=styles.js.map